























import { Component, Vue, Prop } from "vue-property-decorator";
// @ts-ignore
import VClamp from "vue-clamp";

@Component({
    components: {
        VClamp
    }
})
export default class VacancyCard extends Vue {
    @Prop({ required: true }) vacancy!: JobToolzVacancy;

    get vacancyLink() {
        return `/vacatures/${this.vacancy.id}/${this.vacancy.slug}`;
    }
}
